import { useTranslation } from 'react-i18next'
import { Tag } from '@mercai/clever'

import { isDateExpired } from './supplier-product-cost-expiration-tag.constants'

import { SupplierProductCostExpirationTagProps } from './supplier-product-cost-expiration-tag.type'

export const SupplierProductCostExpirationTag = ({
  costExpirationDate,
}: SupplierProductCostExpirationTagProps) => {
  const { t } = useTranslation('componentsSupplierProductCostExpirationTag')

  const isExpired = isDateExpired(costExpirationDate)

  return (
    <Tag variant={isExpired ? 'basic' : 'success'} model="light">
      {isExpired ? t('expired') : t('valid')}
    </Tag>
  )
}
